import React, { useContext } from 'react';
import { RemoveBeanBtn } from '../RemoveBeanBtn';

export const RemoveVehicleBtn = (props) => {

  const label = 'Remove Vehicle'

  return <RemoveBeanBtn {...props} label={label} />;
}